import { FC } from 'react';
import { Stack } from '@chakra-ui/react';
import { useAppContext, useProgram } from '@frx/frx-react-context';
import { AccountInformation } from './columns/account-information/AccountInformation';
import { RegistrationDetails } from './columns/registration-details/RegistrationDetails';
import { EventDetails, Wrapper } from '../../components';
import {
  FragmentIdentifier,
  getContentFragment,
  getFullImagePath,
  isDiyEvent,
  isMemorial,
} from '../../utils';
import { useEventId } from '../../hooks';

export const Registration: FC = () => {
  const {
    data: {
      eventData: { eventInfo },
    },
  } = useAppContext();
  const eventId = useEventId();
  const { data: eventDetailsImage } = useProgram({ variation: `${eventId}` });
  const imgSrc = getContentFragment(
    eventDetailsImage?.data?.programList.items || [],
    FragmentIdentifier.eventDetails,
    eventInfo?.eventType?.toLowerCase()
  );
  const imgPath = getFullImagePath(imgSrc?.image?._path);

  return (
    <Stack direction={['column', 'column', 'column', 'row']} spacing={6}>
      <Wrapper>
        {!isDiyEvent(eventInfo?.eventType) && !isMemorial(String(eventId)) && (
          <EventDetails
            image={imgPath}
            isEditable={false}
            eventInfo={eventInfo}
          />
        )}
        <AccountInformation />
      </Wrapper>
      <Wrapper>
        <RegistrationDetails />
      </Wrapper>
    </Stack>
  );
};
